import { useIntl } from 'react-intl';

export interface FilterOperator {
 operator: string; text: string;
}
export type FilterType = 'text' | 'boolean' | 'date' | 'numeric';

/* Advanced Filter Dropdown options per type (Kendo localization message keys, not display text) */
export const customStringOperators: FilterOperator[] = [
    { operator: 'contains', text: 'filter.containsOperator' },
    { operator: 'doesnotcontain', text: 'filter.notContainsOperator' },
    { operator: 'eq', text: 'filter.eqOperator' },
    { operator: 'neq', text: 'filter.notEqOperator' },
    { operator: 'startswith', text: 'filter.startsWithOperator' },
    { operator: 'endswith', text: 'filter.endsWithOperator' }
];

export const customBooleanOperators: FilterOperator[] = [
    { operator: 'eq', text: 'filter.eqOperator' },
    { operator: 'neq', text: 'filter.notEqOperator' }
];

export const customDateOperators: FilterOperator[] = [
    { operator: 'eq', text: 'filter.eqOperator' },
    { operator: 'neq', text: 'filter.notEqOperator' },
    { operator: 'gte', text: 'filter.afterOrEqualOperator' },
    { operator: 'gt', text: 'filter.afterOperator' },
    { operator: 'lt', text: 'filter.beforeOperator' },
    { operator: 'lte', text: 'filter.beforeOrEqualOperator' }
];

export const customNumericOperators: FilterOperator[] = [
    { operator: 'eq', text: 'filter.eqOperator' },
    { operator: 'neq', text: 'filter.notEqOperator' },
    { operator: 'gte', text: 'filter.gteOperator' },
    { operator: 'gt', text: 'filter.gtOperator' },
    { operator: 'lte', text: 'filter.lteOperator' },
    { operator: 'lt', text: 'filter.ltOperator' }
];

export const Operators = {
    boolean: customBooleanOperators,
    date: customDateOperators,
    numeric: customNumericOperators,
    text: customStringOperators
};

/*
 * Kendo Table Advanced Search Fields.
 * Each field set is a hook so its labels resolve through react-intl.
 */

export const useStudentDefaultLookupSearchFields = () => {

    const { formatMessage } = useIntl();

    return [
        {
            name: 'Fullname',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'name.5458f379', defaultMessage: 'Name' }),
            operators: customStringOperators
        },
        {
            name: 'Username',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'username.dceab582', defaultMessage: 'Username' }),
            operators: customStringOperators
        },
        {
            name: 'Email',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'email.500d9e86', defaultMessage: 'Email' }),
            operators: customStringOperators
        },
        {
            name: 'IsAda',
            filter: 'boolean' as FilterType,
            label: formatMessage({ id: 'accomodations.6e700937', defaultMessage: 'Accomodations' }),
            operators: customBooleanOperators
        },
        {
            name: 'LastAccessDateString',
            filter: 'date' as FilterType,
            label: formatMessage({ id: 'last_login.0b7d4377', defaultMessage: 'Last Login' }),
            operators: customDateOperators
        },
        {
            name: 'GroupsString',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'groups.931a7e94', defaultMessage: 'Groups' }),
            operators: customStringOperators
        }
    ];

};

export const partnerOrderTableSearchFields = [];

export const useTransactionDefaultLookupSearchFields = () => {

    const { formatMessage } = useIntl();

    return [
        {
            name: 'Name',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'name.5458f379', defaultMessage: 'Name' }),
            operators: customStringOperators
        },
        {
            name: 'NumOfStudents',
            filter: 'numeric' as FilterType,
            label: formatMessage({ id: 'number_of_students.24d788d2', defaultMessage: 'Number of Students' }),
            operators: customNumericOperators
        },
        {
            name: 'Groups',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'groups.931a7e94', defaultMessage: 'Groups' }),
            operators: customStringOperators
        },
        {
            name: 'Instructor',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'instructor.845e6d37', defaultMessage: 'Instructor' }),
            operators: customStringOperators
        },
        {
            name: 'CreatedDateString',
            filter: 'date' as FilterType,
            label: formatMessage({ id: 'created_date.b2cdf64f', defaultMessage: 'Created Date' }),
            operators: customDateOperators
        },
        {
            name: 'ExpirationDateString',
            filter: 'date' as FilterType,
            label: formatMessage({ id: 'due_date.712b37be', defaultMessage: 'Due Date' }),
            operators: customDateOperators
        }
    ];

};

export const useGroupDefaultLookupSearchFields = () => {

    const { formatMessage } = useIntl();

    return [
        {
            name: 'Name',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'name.5458f379', defaultMessage: 'Name' }),
            operators: customStringOperators
        },
        {
            name: 'Instructors',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'instructors.24923680', defaultMessage: 'Instructors' }),
            operators: customStringOperators
        },
        {
            name: 'StudentCount',
            filter: 'numeric' as FilterType,
            label: formatMessage({ id: 'number_of_students.24d788d2', defaultMessage: 'Number of Students' }),
            operators: customNumericOperators
        },
        {
            name: 'TransactionCount',
            filter: 'numeric' as FilterType,
            label: formatMessage({ id: 'number_of_transactions.0f7d4ab3', defaultMessage: 'Number of Transactions' }),
            operators: customNumericOperators
        },
        {
            name: 'DateCreate',
            filter: 'date' as FilterType,
            label: formatMessage({ id: 'date_created.85efe6f3', defaultMessage: 'Date Created' }),
            operators: customDateOperators
        }
    ];

};

export const useTransactionDefaultActivitySearchFields = () => {

    const { formatMessage } = useIntl();

    return [
        {
            name: 'Date',
            filter: 'date' as FilterType,
            label: formatMessage({ id: 'date.3427e40d', defaultMessage: 'Date' }),
            operators: customDateOperators
        },
        {
            name: 'StudentName',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'student_name.f4347b21', defaultMessage: 'Student Name' }),
            operators: customStringOperators
        },
        {
            name: 'Name',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'product_name.a24aa58d', defaultMessage: 'Product Name' }),
            operators: customStringOperators
        }
    ];

};

export const useTransactionDefaultPerformanceSearchFields = () => {

    const { formatMessage } = useIntl();

    return [
        {
            name: 'Transaction',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'transaction.c1cf34ac', defaultMessage: 'Transaction' }),
            operators: customStringOperators
        },
        {
            name: 'Product',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'product.3ff5f045', defaultMessage: 'Product' }),
            operators: customStringOperators
        },
        {
            name: 'Assigned',
            filter: 'date' as FilterType,
            label: formatMessage({ id: 'assigned.f0b32a15', defaultMessage: 'Assigned' }),
            operators: customDateOperators
        },
        {
            name: 'AverageTimeSpent',
            filter: 'numeric' as FilterType,
            label: formatMessage({ id: 'average_time_spent.411b3ea0', defaultMessage: 'Average Time Spent' }),
            operators: customNumericOperators
        },
        {
            name: 'AverageScore',
            filter: 'numeric' as FilterType,
            label: formatMessage({ id: 'average_score.3cb75673', defaultMessage: 'Average Score' }),
            operators: customNumericOperators
        }
    ];

};

export const useInstructorGMetrixTableDialogSearchFields = () => {

    const { formatMessage } = useIntl();

    return [
        {
            name: 'FirstName',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'first_name.759a675b', defaultMessage: 'First Name' }),
            operators: customStringOperators
        },
        {
            name: 'LastName',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'last_name.029e7273', defaultMessage: 'Last Name' }),
            operators: customStringOperators
        },
        {
            name: 'EmailAddress',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'email.500d9e86', defaultMessage: 'Email' }),
            operators: customStringOperators
        },
        {
            name: 'RoleId',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'role.a3eb6aa3', defaultMessage: 'Role' }),
            operators: customStringOperators
        },
        {
            name: 'IsActive',
            filter: 'boolean' as FilterType,
            label: formatMessage({ id: 'active_instructor.f6d38609', defaultMessage: 'Active Instructor' }),
            operators: customBooleanOperators
        },
        {
            name: 'AddUsersPermission',
            filter: 'boolean' as FilterType,
            label: formatMessage({ id: 'add_user_permission.6a8c75ba', defaultMessage: 'Add User Permission' }),
            operators: customBooleanOperators
        }
    ];

};

export const useFeatureFlagGMetrixTableSearchFields = () => {

    const { formatMessage } = useIntl();

    return [
        {
            name: 'Name',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'flag.fea8fb19', defaultMessage: 'Flag' }),
            operators: customStringOperators
        },
        {
            name: 'DisplayName',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'name.5458f379', defaultMessage: 'Name' }),
            operators: customStringOperators
        },
        {
            name: 'CreateDate',
            filter: 'date' as FilterType,
            label: formatMessage({ id: 'created_date.b2cdf64f', defaultMessage: 'Created Date' }),
            operators: customDateOperators
        },
        {
            name: 'Description',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'description.6317db73', defaultMessage: 'Description' }),
            operators: customStringOperators
        }
    ];

};

export const useFeatureRingManageUserSearchFields = () => {

    const { formatMessage } = useIntl();

    return [
        {
            name: 'Firstname',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'first_name.759a675b', defaultMessage: 'First Name' }),
            operators: customStringOperators
        },
        {
            name: 'Lastname',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'last_name.029e7273', defaultMessage: 'Last Name' }),
            operators: customStringOperators
        },
        {
            name: 'Username',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'username.dceab582', defaultMessage: 'Username' }),
            operators: customStringOperators
        },
        {
            name: 'RingId',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'ringid.8c0f3ea4', defaultMessage: 'RingId' }),
            operators: customStringOperators
        }
    ];

};

export const usePartnerDefaultLookupSearchFields = () => {

    const { formatMessage } = useIntl();

    return [
        {
            name: 'Name',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'name.5458f379', defaultMessage: 'Name' }),
            operators: customStringOperators
        }
    ];

};

export const useLicenseDefaultLookupSearchFields = () => {

    const { formatMessage } = useIntl();

    return [
        {
            name: 'Name',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'name.5458f379', defaultMessage: 'Name' }),
            operators: customStringOperators
        }
    ];

};

export const useUserDefaultLookupSearchFields = () => {

    const { formatMessage } = useIntl();

    return [
        {
            name: 'FirstName',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'first_name.759a675b', defaultMessage: 'First Name' }),
            operators: customStringOperators
        },
        {
            name: 'LastName',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'last_name.029e7273', defaultMessage: 'Last Name' }),
            operators: customStringOperators
        },
        {
            name: 'UserName',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'username.dceab582', defaultMessage: 'Username' }),
            operators: customStringOperators
        },
        {
            name: 'Email',
            filter: 'text' as FilterType,
            label: formatMessage({ id: 'email.500d9e86', defaultMessage: 'Email' }),
            operators: customStringOperators
        }
    ];

};
